import axiosClient from "../axioxClient.ts/axiosClient";

export interface INotification {
  id: number;
  message: string;
  sender?: string;
  readBy?: number[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

export interface CreateNotificationDto {
  message: string;
  sender?: string;
  readBy?: number[];
  [key: string]: any;
}

export interface NotificationCountResponse {
  count: number;
  unreadCount: number;
}

export const createNotification = async (
  data: CreateNotificationDto,
): Promise<INotification> => {
  const response = await axiosClient.post<INotification>("/notifications", data);
  return response.data;
};

export const fetchNotifications = async (
  limit?: number,
): Promise<INotification[]> => {
  const params: Record<string, any> = {};
  if (limit !== undefined && limit > 0) {
    params.limit = limit;
  }
  const response = await axiosClient.get<INotification[]>("/notifications", {
    params,
  });
  return response.data || [];
};

export const fetchNotificationCount = async (
  userId?: number,
): Promise<NotificationCountResponse> => {
  const params: Record<string, any> = {};
  if (userId) {
    params.userId = userId;
  }
  const response = await axiosClient.get<NotificationCountResponse>(
    "/notifications/count",
    { params },
  );
  return response.data;
};

export const markNotificationAsRead = async (
  id: number,
  userId?: number,
): Promise<INotification> => {
  const params: Record<string, any> = {};
  if (userId) {
    params.userId = userId;
  }
  const response = await axiosClient.patch<INotification>(
    `/notifications/${id}/read`,
    { userId },
    { params },
  );
  return response.data;
};

export const markAllNotificationsAsRead = async (
  userId?: number,
): Promise<{ success: boolean; count: number }> => {
  const params: Record<string, any> = {};
  if (userId) {
    params.userId = userId;
  }
  const response = await axiosClient.patch<{ success: boolean; count: number }>(
    "/notifications/read-all",
    {},
    { params },
  );
  return response.data;
};

